import React from 'react';


function Footer() {
  return (
    <footer className="app-footer">
      <p>&copy; 2024 Mars Mission. All rights reserved.</p>
    </footer>
  );
}

export default Footer;
